module.exports = __webpack_public_path__ + "fonts/d4f0ebf5d59c08236fe25bb12820c2bd.ttf";